const AUTOSYNC = 'autosync'
const BUFFERING = 'buffering'
const DISCONNECTED = 'disconnected'
const FAILED = 'failed'
const INITIALIZING = 'initializing'
const INTERRUPTED = 'interrupted'
const MISSING = 'missing'
const PAUSED = 'paused'
const PLAYING = 'playing'
const STOPPED = 'stopped'
const UNDEFINED = 'undefined'

export default {
  AUTOSYNC,
  BUFFERING,
  DISCONNECTED,
  FAILED,
  INITIALIZING,
  INTERRUPTED,
  MISSING,
  PAUSED,
  PLAYING,
  STOPPED,
  UNDEFINED
}



// WEBPACK FOOTER //
// ./src/lib/states.js